var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apply-banner"},[_c('div',{staticClass:"apply-name"},[_c('h2',[_vm._v(_vm._s(_vm.post.service_name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }